<template>
  <VoiceRight />
</template>

<script>
export default {
    data() {
        return {
        }
    }
}
</script>
